module.exports = __webpack_public_path__ + "images/81f2a52d758fe20694296893448f3afa.png";